import React, { useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import { useWindowSize } from "@uidotdev/usehooks";
import LoadingOverlay from "./LoadingOverlay";
import { DEFAULT_COLUMN_DEF, STATUS_BAR, GRID_OPTIONS } from "./gridConfig";
import css from "./styles.styl";

const DataGrid = ({ data, columns, isLoading }) => {
    const gridRef = useRef(null);
    const size = useWindowSize();

    return (
        <div className={css.gridContainer}>
            <LoadingOverlay isLoading={isLoading}>
                <div className={`ag-theme-quartz ${css.gridWrapper}`} style={{ height: "80vh" }}>
                    <AgGridReact
                        ref={gridRef}
                        animateRows={false}
                        defaultColDef={DEFAULT_COLUMN_DEF}
                        rowData={data ?? []}
                        columnDefs={columns}
                        isRowSelectable={() => false}
                        statusBar={STATUS_BAR}
                        enableRangeSelection={true}
                        suppressContextMenu={false}
                        rowSelection="multiple"
                        gridOptions={GRID_OPTIONS}
                    />
                </div>
            </LoadingOverlay>
        </div>
    );
};

export default DataGrid;